import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import ContentCard from '../components/Cards/ContentCard';
import BigCard from '../components/Cards/BigCard';
import { useTranslation } from '../hook/Translation';


export default function EmtoneCelluliteSmoothing() {
    const { t } = useTranslation();
    const accodirons = [
        {
            title: t('what'),
            content: t('emtone_cellulite_smoothing.what'),
        },
        {
            title: t('how'),
            content: t('emtone_cellulite_smoothing.how'),
        },
        {
            title: t('benefits'),
            content: t('emtone_cellulite_smoothing.benefits'),
        },
        {
            title: t('zone'),
            content: t('emtone_cellulite_smoothing.zone'),
        },
        // {
        //     title: t('pairs'),
        //     content: `EMTONE mund të kombinohet me EMSCULPT NEO për rezultate më të plota në konturimin trupor. Ndërsa EMSCULPT NEO redukton yndyrën dhe ndërton masë muskulore, EMTONE përmirëson strukturën e lëkurës dhe redukton celulitin. Ky kombinim trajton formën, tonusin dhe teksturën e lëkurës në mënyrë të integruar.`,
        // },
        {
            title: t('when_expected_results'),
            content: t('emtone_cellulite_smoothing.expected_results'),
        },
        {
            title: t('results'),
            content: t('emtone_cellulite_smoothing.results'),
        },
    ]

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('emtone_cellulite_smoothing.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('emtone_cellulite_smoothing.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('emtone_cellulite_smoothing.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('emtone_cellulite_smoothing.sessions'),
        }
    ]

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f355d421d426.30209997.jpg`} height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'}marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    // titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: t('bodyherapies'),
                        title: t('emtone_cellulite_smoothing.mainTitle'),
                        description: t('emtone_cellulite_smoothing.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMTONE")}`,
                        learn: "",
                        price: `${t('price_session')} €150\n${t('price_package')} 4 ${t('price_seanc')}: €450`,

                        doctorIncluded: true
                    }}
                />
            </Box>
            <Box marginTop={{md: '118px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{md: '144px', xs: '50px'}} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>
 <Grid container className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '141px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{md: '30px', xs: '1.125rem'}}>
{t('emtone_cellulite_smoothing.bigDesc')}
                    </Typography>
                </Grid>
            </Grid>
                <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} marginTop={{md: '140px', xs: '50px'}}>
                <Box sx={{ height: { md: 440, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMTONE")}`,
                            type: t('emtone_cellulite_smoothing.tech'),
                            // learn: '/',
                            title: t('emtone_cellulite_smoothing.techTitle'),
                            size: { md: 7, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/03/ALMA.png`,
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('emtone_cellulite_smoothing.techDesc'),
                            imageSize: {md: 5, xs: 12}
                        }}
                        bgColor={'rgba(30, 53, 61, 1)'}
                    />
                </Box>
            </Box>
           

            <Grid container spacing={4} className='generalContainer' sx={{ marginX: 'auto'}} marginTop={{md: '103px', xs: '50px'}}>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>
            

        
{/* 
            <Grid container gap={{md: '80px', xs: '50px'}} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '80px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid> */}

            <Box bgcolor={'#DBDAD9'} marginTop={{md: '128px', xs: '50px'}} paddingTop={{md: '127px', xs: '50px'}} paddingBottom={{md: '243px', xs: '50px'}}>
                <Box className="generalContainer" marginX={'auto'} gap={{md: '89px', xs:'50px'}} display={'flex'} flexDirection={'column'}>
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Emtone2.png`,
                            type: t('emtone_cellulite_smoothing.card_pairs'),
                            title: 'Emsculpt NEO',
                            description: t('emtone_cellulite_smoothing.card_desc'),
                            direction: { md: 'row-reverse', xs: 'column-reverse' },
                            learn: "/body/emsculpt-neo-muscle-build-and-fat-reduction",
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EMSCULPT NEO")}`
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Emoten---resurfacig2.png`,
                            type: t('emtone_cellulite_smoothing.card_pairs2'),
                            title: 'Exion RF Tightening',
                            description: t('emtone_cellulite_smoothing.card_desc2'),
                            learn: "/body/exion-rf-body-skin-tightening",
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION BODY")}`
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    {/* <ContentCard
                        data={{
                            type: 'Pairing',
                            title: 'Lymphatic Drainage Massage',
                            description: 'Even manual lymphatic drainage massage or our Lymphatic Radiance Boost facial (for upper body cellulite like arms) can complement Emtone by further enhancing fluid drainage. Best of all, there’s no downtime, so you can combine these and immediately return to daily life.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            learn: "/skin/hybrid-laser-erbium-glass",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            type: 'Pairing',
                            title: 'Lymphatic Radiance Boost',
                            description: 'Even manual lymphatic drainage massage or our Lymphatic Radiance Boost facial (for upper body cellulite like arms) can complement Emtone by further enhancing fluid drainage. Best of all, there’s no downtime, so you can combine these and immediately return to daily life.',
                            learn: "/skin/hybrid-laser-erbium-glass",
                            book: '/'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    /> */}
                </Box>
            </Box>
        </Box>
    )
}